import React from "react";
import { Checkbox } from "antd";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { setTriggers } from "../../actions";
import { EVENT_TRIGGERS } from "../../DefaultValue/eventCatalog";

export const TriggerPreferences = ({ translation, fonts }) => {
  const dispatch = useDispatch();
  const checkedTriggers = useSelector(
    (state) => state.newsEventPage.subscription.triggers
  );
  const triggers = checkedTriggers || [];

  const onChangeCheckBox = (trigger) => (e) => {
    if (e.target.checked) {
      dispatch(setTriggers([...triggers, trigger]));
    } else {
      dispatch(setTriggers(triggers.filter((item) => item !== trigger)));
    }
  };

  return (
    <div className="trigger-preferences-wrapper">
      {EVENT_TRIGGERS.map((trigger) => {
        const copy = translation[trigger] || {};
        return (
          <div className="trigger-cell-wrapper" key={trigger}>
            <div className="trigger-cell-left-block">
              <div className="trigger-cell-title-text-wrapper">
                <Checkbox
                  checked={triggers.includes(trigger)}
                  onChange={onChangeCheckBox(trigger)}
                />
                <span
                  className="trigger-cell-title-text"
                  style={{ color: fonts.body }}
                >
                  {copy.title}
                </span>
              </div>
              <div className="trigger-cell-info-block">
                <span
                  className="trigger-cell-description-text"
                  style={{ color: fonts.body }}
                >
                  {copy.description}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
